export const API_BASE_URL = process.env.REACT_APP_API;
export const COMPANY_NAME = 'Itoagent.com';
export const COMPANY_ABN = `61 511 422 845`;

export const PRIVACY_POLICY_PAGE_LINK = `/privacy-policy`;
export const TERMS_OF_USE_PAGE_LINK = `/terms-of-use`;

export const REGISTER_PAGE_LINK = `/register`;
export const PRICE_PAGE_LINK = `/register`;
export const CONTACT_PAGE_LINK = `/contact`;
export const ABOUT_PAGE_LINK = `/about`;
